import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MagasinSimulationService {
  simulatedMagasinId = signal<number | null>(this.loadFromStorage('simulated_magasin_id'));
  simulatedMagasinNom = signal<string | null>(this.loadFromStorage('simulated_magasin_nom'));

  isSimulating = computed(() => this.simulatedMagasinId() !== null);

  setSimulation(magasinId: number, nom: string): void {
    this.simulatedMagasinId.set(magasinId);
    this.simulatedMagasinNom.set(nom);
    localStorage.setItem('simulated_magasin_id', String(magasinId));
    localStorage.setItem('simulated_magasin_nom', nom);
  }

  clearSimulation(): void {
    this.simulatedMagasinId.set(null);
    this.simulatedMagasinNom.set(null);
    localStorage.removeItem('simulated_magasin_id');
    localStorage.removeItem('simulated_magasin_nom');
  }

  private loadFromStorage(key: string): any {
    const value = localStorage.getItem(key);
    if (key === 'simulated_magasin_id' && value) {
      return parseInt(value, 10);
    }
    return value;
  }
}
